import { REGISTRATION_STATUS_ACTIVE, REGISTRATION_STATUS_PENDING } from "./crmPayload";

export type AccountSetupCrmResult = {
  ok: boolean;
  message?: string;
  resolvedStatus?: string;
};

/** Parse `POST /api/buxus/account-setup-crm` response (legacy Zoho upsert shape). */
export function parseAccountSetupCrmResponse(res: unknown): AccountSetupCrmResult {
  const r = res as {
    data?: Array<{ code?: string; message?: string; status?: string }>;
    message?: string;
    resolvedStatus?: string;
  };
  const row = r.data?.[0];
  const code = row?.code;
  if (code === "SUCCESS") {
    const resolved =
      (typeof r.resolvedStatus === "string" && r.resolvedStatus.trim()) ||
      (typeof row?.status === "string" && row.status.trim()) ||
      undefined;
    return { ok: true, resolvedStatus: resolved };
  }
  const hint =
    code === "LOCATION_NOT_FOUND"
      ? "We could not save your location selections right now. Please try again in a few minutes, or contact support if this keeps happening."
      : undefined;
  return {
    ok: false,
    message: row?.message || r.message || hint || "Registration could not be completed.",
  };
}

export function isRegistrationPendingStatus(status: string | null | undefined): boolean {
  return status?.trim() === REGISTRATION_STATUS_PENDING;
}

export function isRegistrationActiveStatus(status: string | null | undefined): boolean {
  return status?.trim() === REGISTRATION_STATUS_ACTIVE;
}
